/**
 * Section B5 Service - B.5.額外性說明
 */
import axios from '../api/axios';

const BASE_URL = '/api/section-b5';

export interface SectionB5Detail {
  id: number;
  organization_id: number;
  project_id: number;
  regulatory_analysis: string | null;
  avoidance_lockin: string | null;
  financial_performance_type: number[] | null;
  financial_performance: string | null;
  common_practice_analysis: string | null;
  b_5: number;
  edit_by: number | null;
  created_at: string;
  updated_at: string | null;
}

export interface SectionB5Update {
  regulatory_analysis?: string;
  avoidance_lockin?: string;
  financial_performance_type?: number[];
  financial_performance?: string;
  common_practice_analysis?: string;
}

export const getSectionB5ByProject = async (projectId: number): Promise<SectionB5Detail | null> => {
  const response = await axios.get<SectionB5Detail>(`${BASE_URL}/by-project/${projectId}`);
  return response.data;
};

export const updateSectionB5 = async (projectId: number, data: SectionB5Update): Promise<SectionB5Detail> => {
  const response = await axios.put<SectionB5Detail>(`${BASE_URL}/${projectId}`, data);
  return response.data;
};

const sectionB5Service = { getSectionB5ByProject, updateSectionB5 };
export default sectionB5Service;
